import { render, staticRenderFns } from "./DvtManagementTool.vue?vue&type=template&id=6aca60d3&"
import script from "./DvtManagementTool.vue?vue&type=script&lang=js&"
export * from "./DvtManagementTool.vue?vue&type=script&lang=js&"
import style0 from "./DvtManagementTool.vue?vue&type=style&index=0&id=6aca60d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports